"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Yup = tslib_1.__importStar(require("yup"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const graphql_2 = require("../../../../graphql");
const hooks_1 = require("../../../../hooks");
const react_2 = require("@osmosys/react");
exports.Settings = ({ template }) => {
    const { del, delResult } = hooks_1.useDeleteEmailTemplate(template.id);
    return (react_1.default.createElement(reactstrap_1.Row, { className: "justify-content-center" },
        react_1.default.createElement(reactstrap_1.Col, { md: "6" },
            react_1.default.createElement(reusables_1.Form, { mutationProps: {
                    mutation: graphql_1.updateEmailTemplate,
                    refetchQueries: [
                        {
                            query: graphql_2.emailTemplate,
                            variables: {
                                id: template.id,
                            },
                        },
                    ],
                }, valuesToVariables: values => {
                    return {
                        data: {
                            name: values.name.trim(),
                            url: values.url ? values.url.trim() : null,
                        },
                        id: template.id,
                    };
                }, formikProps: {
                    initialValues: {
                        name: template.name || '',
                        url: template.url || '',
                    },
                    validationSchema: Yup.object().shape({
                        name: Yup.string()
                            .trim()
                            .required('Required'),
                        url: Yup.string()
                            .trim()
                            .url(),
                    }),
                }, showBottomToolbar: true }, (formikProps, mutationResult) => (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "Name", name: "name" }),
                react_1.default.createElement(reusables_1.FormGroup, { label: "URL to template code", name: "url" }),
                react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "EmailTemplate", action: "update", apolloError: mutationResult.error })))),
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.AjaxButton, { loading: delResult.loading, success: !!delResult.data, error: delResult.error, label: "Delete", color: "warning", className: "my-3", icon: pro_solid_svg_icons_1.faTrash, onConfirmation: () => {
                        del();
                    }, type: "button", confirmationYesMessage: "Yes, delete", confirmationMessage: "Are you sure you want to delete this template?", confirmationFinePrint: "This cannot be undone." }),
                react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "EmailTemplate", action: "delete", apolloError: delResult.error })))));
};
//# sourceMappingURL=Settings.js.map